<template>
	<div class="preview">
		<header class="preview__header">
			<button class="preview__back-button"></button>
			{{ title }}
		</header>
		<ul class="preview__list">
			<li
				class="preview__list__item"
				v-for="(item, idx) in productList"
				:key="idx"
			>
				<div class="preview__list__item__product">
					<p class="product__brand">
						{{ item.brandTitle }}
					</p>
					<p class="product__name">{{ item.productTitle }}</p>
					<div class="product__info price">
						<p class="product__info__text">
							가격
							<span class="product__info__value">
								{{ item.volume
								}}{{ item.price ? ` / ${item.price}` : '' }}
							</span>
						</p>
					</div>
					<div class="product__info average">
						<p class="product__info__text">
							평점
							<span class="product__info__value">
								{{ item.ratingAvg.toFixed(2) }} ({{
									getPercent(
										item.rationCount,
										item.rating4 + item.rating5
									)
								}})
							</span>
						</p>
					</div>
					<div class="product__info review">
						<p class="product__info__text">
							리뷰
							<span class="product__info__value">{{
								item.rationCount
							}}</span>
						</p>
					</div>
					<img class="product__img" :src="item.imageUrl" />
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
	import { mapState } from 'vuex';

	export default {
		name: 'ThemePreview',
		data() {
			return {
				productList: [],
			};
		},
		computed: {
			...mapState({
				title: state => state.modal.params.title,
				productIds: state => state.modal.params.productIds,
			}),
		},
		created() {
			this.getList();
		},
		methods: {
			getPercent(total, numerator) {
				return (
					(numerator ? Math.floor((numerator / total) * 100) : 0) +
					'%'
				);
			},
			async getList() {
				const params = {
					id: this.productIds.join(','),
				};
				const { data } = await this.$axiosAdmin2.get(
					'/v3/api/theme/preview',
					{ params }
				);
				this.productList = data;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.preview {
		width: 377px;
		margin: 0 auto;
		border: solid 1px #f0f1f5;
	}

	.preview__header {
		height: 56px;
		padding: 16px;
		line-height: 24px;
		text-align: center;
		color: black;
		font-size: 16px;
		font-weight: 700;
	}

	.preview__back-button {
		width: 24px;
		height: 24px;
		background: no-repeat center/24px url('/static/img/icon/back.png');
		float: left;
	}

	.preview__list {
		margin-top: 12px;
		padding: 0 16px;
	}

	.preview__list__item {
		margin-bottom: 16px;
	}

	.preview__list__item__product {
		position: relative;
		padding: 16px 136px 12px 16px;
		background: white;
		border: 1px solid #f6f7fa;
		box-shadow: 0px 3px 10px rgba(black, 0.08);
		border-radius: 8px;
	}

	.product__brand {
		overflow: hidden;
		display: block;
		color: #6f6f6f;
		font-size: 14px;
		text-decoration: underline;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.product__name {
		overflow: hidden;
		display: -webkit-box;
		height: 38px;
		margin: 2px 0;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		word-break: break-all;
		line-height: 19px;
		color: black;
		font-size: 13px;
	}

	.product__info {
		display: flex;
		align-items: center;

		&:before {
			content: '';
			display: block;
			width: 16px;
			height: 16px;
			background: no-repeat center / 16px;
			flex-shrink: 0;
		}

		&.price:before {
			background-image: url('/static/img/icon/price.png');
		}

		&.average:before {
			background-image: url('/static/img/icon/star.png');
		}

		&.review:before {
			background-image: url('/static/img/icon/pen.png');
		}
	}

	.product__info__text {
		overflow: hidden;
		display: block;
		padding-left: 4px;
		line-height: 18px;
		color: #8b8b8b;
		font-size: 12px;
		font-weight: 400;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.product__info__value {
		color: #4d4d4d;
	}

	.product__img {
		position: absolute;
		display: block;
		top: 24px;
		right: 16px;
		width: 108px;
		height: 108px;
	}
</style>
